import { put, call, takeEvery } from 'redux-saga/effects'
import { RestHelper } from '../helpers/RestHelper'
import  * as LogInActions from '../actions/LogInActions'
import { ErrorType } from '../datatypes/ErrorType'
import { LocalTokenHelper } from '../helpers/LocalTokenHelper'

const logInToServer = function*(action: LogInActions.ILogInUserAction) : any {
    try {
        // Make the REST request to the server to log the user in.
        let response: Response = yield call(RestHelper.post, `${RestHelper.RootUrl}/sdk/token`, action.body, false)

        if (response.ok)
        {
            let json:any = yield response.json();

            // Update the local state in memory for token access.
            LocalTokenHelper.saveLoginTokens(json.access_token, json.refresh_token);

            // Refresh the UI now that we've successfully signed in.
            yield put({type: LogInActions.LOG_IN_USER_COMPLETED_ACTION_TYPE, json: json, errorType: ErrorType.Success});
        }
        else if (response.status == 400)
        {
            let json:any = yield response.json();
            yield put({type: LogInActions.LOG_IN_USER_COMPLETED_ACTION_TYPE, errorType: ErrorType.UserError, errorMessage: json.error_description});
        }
        else
        {
            let json:any = yield response.json();
            yield put({type: LogInActions.LOG_IN_USER_COMPLETED_ACTION_TYPE, errorType: ErrorType.ServerError, errorMessage: json});
        }
    }
    catch (e: any) {
        yield put({type: LogInActions.LOG_IN_USER_COMPLETED_ACTION_TYPE, errorType: ErrorType.LocalError, errorMessage: e.message});
    }
}

const logInUserLocally = function*(action: LogInActions.ILogInUserLocalAction) {
    // Update the UI.
    let token = LocalTokenHelper.getLoginToken();
    yield put({type: LogInActions.LOG_IN_USER_COMPLETED_ACTION_TYPE, json: { access_token: token }, errorType: ErrorType.Success});
}

const logOutUser = function*(action: LogInActions.ILogOutUserAction) {
    // Update the UI.
    yield put({type: LogInActions.LOG_OUT_USER_COMPLETED_ACTION_TYPE});
}

export const logInToServerSaga = function*() {
    yield takeEvery(LogInActions.LOG_IN_USER_ACTION_TYPE, logInToServer);
}

export const logInUserLocallySaga = function*() {
    yield takeEvery(LogInActions.LOG_IN_USER_LOCALLY_ACTION_TYPE, logInUserLocally);
}

export const logOutUserSaga = function*() {
    yield takeEvery(LogInActions.LOG_OUT_USER_ACTION_TYPE, logOutUser);
}